import type { DropdownOption, WorkExperienceType } from '@talentmesh/utils';
import UIStrings from '@/Utils/UIStrings';

function workExperienceToString(workExperience: WorkExperienceType): string {
    switch (workExperience) {
        case 'GraduateOrAnalyst':
            return UIStrings.GraduateOrAnalyst;
        case 'Associate':
            return UIStrings.Associate;
        case 'Manager':
            return UIStrings.Manager;
        case 'Director':
            return UIStrings.Director;
        case 'CLevelOrManagingDirector':
            return UIStrings.CLevelOrManagingDirector;
        default:
            return '';
    }
}

const workExperienceList: Array<WorkExperienceType> = [
    'GraduateOrAnalyst',
    'Associate',
    'Manager',
    'Director',
    'CLevelOrManagingDirector',
];

const workExperienceOptions: DropdownOption[] = workExperienceList.map((item) => {
    return { id: item, name: workExperienceToString(item) };
});

export default workExperienceOptions;
